import { selectVehicleTypesState } from '../index';
import { createSelector } from '@ngrx/store';
import { VehicleTypesState } from '../reducers/vehicle-types.reducer';

export const selectVehicleTypes = createSelector(
  selectVehicleTypesState,
  (state: VehicleTypesState) => state && state.vehicleTypes
);
export const selectVehicleTypesLoading = createSelector(
  selectVehicleTypesState,
  (state: VehicleTypesState) => state && state.loading
);
export const selectVehicleTypesError = createSelector(
  selectVehicleTypesState,
  (state: VehicleTypesState) => state && state.error
);

// Select sorted vehicle types
export const selectVehicleTypesSorted = createSelector(
  selectVehicleTypes,
  (vehicleTypes: string[] | null) => vehicleTypes && vehicleTypes.slice().sort((a, b) => a.localeCompare(b))
);
